import React, { useState } from "react"

import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Typography from "@mui/material/Typography"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import { Box } from "@mui/material"

const reasons = [
    {
        label: "Produto/serviço fora da necessidade atual",
        value: "givedUp",
    },
    {
        label: "Optou pelo concorrente",
        value: "preferCompetitor",
    },
    {
        label: "Falta de orçamento",
        value: "notEnoughMoney",
    },
    {
        label: "Problemas no atendimento",
        value: "problemWithService",
    },
    {
        label: "Sem retorno do cliente",
        value: "noResponseFromClient",
    },
    {
        label: "Outro",
        value: "another",
    },
]

function ModalCloseTicket({ isOpen, handleCancel, handleConfirm }) {
    const [saleDone, setSaleDone] = useState(true)
    const [selectedReason, setSelectedReason] = useState("")

    const handleChange = (e) => {
        setSaleDone(e.target.value)
    }

    return (
        <Dialog
            open={isOpen}
            onClose={handleCancel}
            maxWidth={saleDone ? "xs" : "sm"}
            fullWidth={!saleDone}
        >
            <DialogTitle>Fechar negociação</DialogTitle>

            <DialogContent>
                <Typography gutterBottom>
                    Você fechou a venda com sucesso?
                </Typography>

                <Box sx={{ mt: 2 }}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                            Selecionar
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={saleDone}
                            label="Selecionar"
                            onChange={handleChange}
                        >
                            <MenuItem value={true}>Sim</MenuItem>
                            <MenuItem value={false}>Não</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                {!saleDone && (
                    <Box sx={{ minWidth: 120, mt: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label-2">
                                Motivo
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label-2"
                                id="demo-simple-select-2"
                                value={selectedReason}
                                label="Motivo"
                                onChange={(e) =>
                                    setSelectedReason(e.target.value)
                                }
                            >
                                {reasons.map((reason) => {
                                    return (
                                        <MenuItem
                                            value={reason.value}
                                            key={reason.value}
                                        >
                                            {reason.label}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Box>
                )}
            </DialogContent>

            <DialogActions>
                <Button color="secondary" onClick={handleCancel}>
                    Cancelar
                </Button>
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() =>
                        handleConfirm({
                            saleCompleted: saleDone,
                            reason: selectedReason,
                        })
                    }
                >
                    Concluir
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ModalCloseTicket
